export default __webpack_public_path__ + "static/media/beat1.e1f33b37.mp3";